export default __webpack_public_path__ + "static/media/logo_sem_adentis.cc9dccda.png";